import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useB2BWallet() {
  const [walletData, setWalletData] = useState(null);
  const [ledgerData, setLedgerData] = useState(null);
  const [impactData, setImpactData] = useState(null);
  const [packages, setPackages] = useState([]);
  const [services, setServices] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [labelData, setLabelData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState('overview');
  const [tenantId, setTenantId] = useState('');
  const [apiKey, setApiKey] = useState('');

  useEffect(() => {
    const storedTenantId = localStorage.getItem('b2b_tenant_id') || 'partner_gcc_gccpartner_6ac6c2d0';
    const storedApiKey = localStorage.getItem('b2b_api_key') || '';
    setTenantId(storedTenantId);
    setApiKey(storedApiKey);
    fetchReferenceData();
  }, []);

  useEffect(() => {
    if (tenantId) {
      fetchWalletData();
      fetchInvoices();
      fetchLabelData();
    }
  }, [tenantId, apiKey]);

  const fetchReferenceData = async () => {
    try {
      const [packagesRes, servicesRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/wallets/packages`),
        axios.get(`${BACKEND_URL}/api/wallets/services`)
      ]);
      setPackages(packagesRes.data.packages || []);
      setServices(servicesRes.data.services || []);
    } catch {
    }
  };

  const fetchWalletData = async () => {
    setLoading(true);
    try {
      const headers = apiKey ? { 'Authorization': `Bearer ${apiKey}` } : {};
      const [balanceRes, ledgerRes, impactRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/wallets/${tenantId}/balance`, { headers }),
        axios.get(`${BACKEND_URL}/api/wallets/${tenantId}/ledger?limit=20`, { headers }),
        axios.get(`${BACKEND_URL}/api/wallets/${tenantId}/impact`, { headers })
      ]);
      setWalletData(balanceRes.data);
      setLedgerData(ledgerRes.data);
      setImpactData(impactRes.data);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error('Access denied - Invalid API key');
      } else {
        toast.error('Error loading wallet data');
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchInvoices = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/billing/sc/invoices?tenant_id=${tenantId}`);
      setInvoices(res.data.invoices || []);
    } catch {
    }
  };

  const fetchLabelData = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/public/verify/${tenantId}`);
      setLabelData(res.data);
    } catch {
    }
  };

  const createOrder = async (packId) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/api/billing/sc/orders`, {
        tenant_id: tenantId,
        pack_id: packId,
        currency: 'EUR',
        payment_method: 'bank_transfer'
      });
      toast.success(`Order ${res.data.order_id} created!`);
      fetchInvoices();
    } catch {
      toast.error('Error creating order');
    }
  };

  return {
    walletData, ledgerData, impactData, packages, services, invoices, labelData,
    loading, selectedTab, setSelectedTab, tenantId, setTenantId, apiKey, setApiKey,
    fetchWalletData, createOrder,
  };
}
